import { Box, Grid, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import QuoteImage from '@/assets/quote.svg';

export const Wrapper = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.grayscale[50],
  paddingTop: theme.spacing(8),

  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(0),
  },
}));

export const VideoWrapper = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  paddingBottom: '56.25%',
  height: 0,
  right: 1,

  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
}));

export const BigImage = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  paddingBottom: '56.25%',
  height: 0,
  right: 1,
}));

export const TextContentWrapper = styled(Stack)(({ theme }) => ({
  height: '100%',
  marginLeft: '20%',

  [theme.breakpoints.down('md')]: {
    paddingLeft: theme.pageMarginHorizontalMobile,
    paddingRight: theme.pageMarginHorizontalMobile,
    marginLeft: 0,
  },
}));

export const TextWrapper = styled(Box)(({ theme }) => ({
  display: 'block',
  position: 'relative',
  flex: 1,
  maxWidth: 300,
  minHeight: '56.25%',

  '&:after': {
    content: '""',
    height: 3,
    border: `1px solid ${theme.palette.grayscale[800]}`,
    position: 'absolute',
    width: '63%',
    bottom: 0,
    left: 0,
    zIndex: 0,
  },

  [theme.breakpoints.down('md')]: {
    height: 250,
    flex: 'initial',
    maxWidth: 'initial',
    minHeight: 'initial',
    marginTop: theme.spacing(4),
  },
}));

export const Quote = styled(QuoteImage)(({ theme }) => ({
  position: 'absolute',
  top: -50,
  left: -10,

  [theme.breakpoints.down('md')]: {
    top: -40,
    left: 0,
  },
}));

export const TileText = styled(Typography)(({ theme }) => ({
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: '13',
  whiteSpace: 'pre-wrap',
  overflow: 'hidden',
  display: '-webkit-box',

  [theme.breakpoints.down('sm')]: {
    WebkitLineClamp: '10',
  },
}));
